import { useStore as getStore } from "../../utils/useStore.js";
import recaptchaFactory from "./recaptchaFactory.js";

const initialState = () => ({
  showRecaptcha: {},
  size: "normal",
  recaptchas: {},
});

const [RecaptchaProvider, useRecaptcha, withRecaptcha] = getStore(
  recaptchaFactory,
  initialState,
  "Recaptcha"
);

export const recaptchaInitState = initialState();

export { useRecaptcha, RecaptchaProvider, withRecaptcha };

export default RecaptchaProvider;
